/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-template */

import { END } from 'redux-saga';
import {
    take, fork, call, select, put,
    takeLatest,
} from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import mbpLogger from 'mbp-logger';
import cartServiceClient from '../../../../../../apis/cart-service-apis/cartServiceClient';
import { getFeatureFlags, getOnePageCheckoutSaleForceABTest } from '../../App/App-Selectors';
import {
    getBillingAddress, getAmount, getOrderId, getPassportSubscriptionStatus,
    getRecipients, isPassportInCart,
} from '../../Cart/Cart-Selectors';
import { saveBannerProcessCheckCompleted, saveExtraAttributesCompleted } from '../../../../Checkout/ducks/Checkout/Checkout-Actions';
import { checkJWT } from '../../../../Checkout/ducks/Global/Global-Operations';
import {
    getEmailOptIn, getOrderStatusOptIn, getPaymentInfo, getPaymentMethod, getSMSOptIn,
} from '../../../../Checkout/ducks/Common/Common-Selectors';
import { getPaypalTokenizedCard } from '../PaymentMethods/Paypal/Paypal-Selectors';
import { billingAddressCheckSameAsDeliveryAddress, billingAddressClearForm, updateBillingAddressInAddressBook } from '../BillingAddress/BillingAddress-Actions';
import { workerSagaUpdateEnterpriseId } from '../../../../Member/ducks/EnterpriseId/EnterpriseId-Operations';
import { flagOffShowLoadingMessage, updateShowLoadingMessage } from '../../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';
import { paymentClearUpdateFields, paymentUpdateFormStatus } from '../../../../Checkout/ducks/Payment/ducks/PaymentForm/PaymentForm-Actions';
import { clearPaypalState } from '../PaymentMethods/Paypal/Paypal-Actions';
import { retrieveCart } from '../../Cart/ducks/RetrieveCart/RetrieveCart-Operations';
import { getBrand } from '../../../../Checkout/ducks/Global/Global-Selectors';
import { payloadClickStreamPlaceOrder } from '../../../../Payment/helpers/payloadGenClickStreamPlaceOrder';
import { applePayMerchantProcess, paymentPlaceOrder, paymentPlaceOrderCompleted } from './PlaceOrder-Actions';
import { clickStreamOrderComplete } from '../../../../Payment/Payment-Actions';
import { unsubscribeEmail, unsubscribeOrderStatus, unsubscribeTextmsg } from '../../../../Checkout/ducks/Payment/ducks/Subscription/Subscription-Action';
import { removePersistPageDataFromStorage } from '../../../../../../app/helpers/EnterpriseID/CustomerDataPersistance/customerDataPersistance';
import { orderCompleteAttributionData } from '../../../../../../app/helpers/attribution/attributionHelpers';
import { postOrderCompleteAttributionData } from '../../../../Checkout/ducks/Payment/Payment-Actions';
import { getTokenLocalStorage, setTokenLocalStorage } from '../../../../Member/ducks/Auth/helper/helper';
import { setProfileDetails } from '../../../../Member/ducks/Profile/Profile-Actions';
import { processFeatureErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Operations';
import { getGooglePayTokenizedCard } from '../PaymentMethods/GooglePay/GooglePay-Selectors';
import { clearOrderItemErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Actions';
import { getRewardPointsInfo } from '../RewardPoints/RewardPoints-Selectors';
import { getCountryCodeFromTwoToThreeDigit } from '../../../../Checkout/helpers/countryCode';
import { trackEvent } from '../../../../TagManager/ducks/TagManager/TagManager-Actions';
import GAInterface from '../../../../../../app/helpers/GoogleAnalyticsInterface';
import { getAnalyticsStorageData } from '../../../../../../app/helpers/tracking/session/sessionTrackingHelpers';
import updateAttribute from '../../../../../../apis/cart-service-apis/updateAttribute';
import { onPersistAttribution } from '../../../../Checkout/ducks/Checkout/Checkout-Operations';
import { collectMetadata } from '../../../../../../app/helpers/common/accertify';
import { isEmpty } from '../../../../../../app/components/Page/helpers/helper';
import { anchorErrorCommonMessage } from '../../../../../../app/pages/Checkout/containers/EnterpriseCheckout/Common/Helpers/Helper';
import { setMfeBannerCodesAttempted } from '../Promotions/Promotion-Actions';

export const parseBannerCookie = () => {
    const cookies = new Cookies();
    const bCookie = cookies.get('banner');

    if (bCookie) {
        const bAttr = JSON.parse(JSON.stringify(bCookie));

        mbpLogger.logInfo({
            bCookie,
            function: 'parseBannerCookie',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout :: checkout',
            message: 'Parsed banner cookie for order upload',
        });

        return bAttr;
    }
    return '';
};

function* placeOrderExtraAttributes() {
    const cartId = yield select(getOrderId);
    const jwtToken = yield call(checkJWT);
    const featureFlags = yield select(getFeatureFlags);

    try {
        const attributes = [];

        // Adding extra attribute from campaing
        const analyticsSession = getAnalyticsStorageData();

        if (analyticsSession?.landingParams?.u1) {
            attributes.push(
                {
                    attributeName: 'bgsu1',
                    attributeValue: analyticsSession.landingParams.u1,
                },
            );
        }

        if (featureFlags['is-ga-clientid-clickstream-enabled']) {
            // get GA Client ID and GA Session ID
            const { gaClientId, gaSessionId } = GAInterface.getGAClientAndSessionId();
            // only call the API if there GA values are not null
            if (gaClientId && gaSessionId) {
                attributes.push(
                    {
                        attributeName: 'GAClientId',
                        attributeValue: gaClientId,
                    },
                );
                attributes.push(
                    {
                        attributeName: 'GASessionId',
                        attributeValue: gaSessionId,
                    },
                );
            }
        }

        if (attributes.length > 0) {
            yield call(updateAttribute, {
                cartId,
                jwtToken,
                attributes,
            });
        }

        yield put(saveExtraAttributesCompleted());
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'PlaceOrder-Operations.js',
            function: 'placeOrderExtraAttributes',
            jsError: ex,
            errorMessage: ex.response,
            message: `PlaceOrder Extra Attributes Failed - ${cartId} - Error occured while adding extra attributes Ex: bgsu1`,
        });
    }
}

function* persistBanner() {
    const logOrderId = yield select(getOrderId);
    const featureFlags = yield select(getFeatureFlags);

    try {
        const bannerObj = parseBannerCookie();
        let bannerCode = bannerObj?.c;

        if (featureFlags['is-checkout-monitoring-enabled']) {
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                module: 'PlaceOrder-Operations.js',
                function: 'persistBanner',
                errorMessage: bannerObj,
                message: `Before Call Persist Banner - ${logOrderId}`,
            });
        }
        const analyticsSession = getAnalyticsStorageData();

        if ((!bannerCode || bannerCode === 'null') && analyticsSession?.landingParams?.r) {
            bannerCode = analyticsSession?.landingParams?.r;
        }

        if (bannerCode) {
            mbpLogger.logInfo({
                function: 'persistBanner',
                errorMessage: bannerObj,
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                message: `Init Call Persist Banner - ${logOrderId} - ${bannerCode}`,
            });
            if (featureFlags['is-checkout-monitoring-enabled']) {
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    module: 'PlaceOrder-Operations.js',
                    function: 'persistBanner',
                    errorMessage: bannerObj,
                    message: `Call Persist Banner - ${logOrderId} - ${bannerCode}`,
                });
            }
            yield fork(onPersistAttribution, { bannerCode, lsid: bannerObj.l }); // c = bannerCode, l= lsid

            yield take(saveBannerProcessCheckCompleted().type);
        } else {
            yield put(saveBannerProcessCheckCompleted());
        }
    } catch (ex) {
        const bannerObj = parseBannerCookie();
        const bannerCode = bannerObj?.c;

        console.log('Debug - error Persist Banner', ex?.response);

        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'PlaceOrder-Operations.js',
            function: 'persistBanner',
            jsError: ex,
            errorMessage: ex.response,
            message: `PersistBanner Failed - ${logOrderId} - ${bannerCode} - Error occured while parsing banner`,
        });
        yield put(saveBannerProcessCheckCompleted());
    }
}

const removeMaskForPhoneNumber = (number) => {
    let strNumber = number.toString().trim();
    strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9+]/g, '');
    if (strNumber.indexOf('+') === 0 && strNumber.indexOf('1') === 1) {
        strNumber = strNumber.substring(2, strNumber.length);
    } else if (strNumber.indexOf('+') >= 0) {
        strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9]/g, '');
    }
    return strNumber;
};

const removeMaskForAccountNumber = (number) => {
    const strAccountNumber = number.toString();
    if (strAccountNumber.indexOf('-') >= 0) {
        return strAccountNumber.split('-').join('');
    }
    return strAccountNumber;
};

const CreditCardTypes = {
    VI: 'Visa',
    MC: 'Master Card',
    DS: 'Discover',
    DI: 'Discover',
    AX: 'American Express',
    PY: 'PayPal',
    GP: 'Google Pay',
    AP: 'Apple Pay',
    VM: 'Venmo',
};

function* buildConfigObj({
    disablePaymentFields,
    paypalPayment,
    venmoPayment,
    klarnaPayment,
    googlePayment,
    pazePayment,
    source,
    recaptcha,
    recaptchaV2,
}) {
    let configObj = {};
    const cartId = yield select(getOrderId);
    const flagState = yield select(getFeatureFlags);

    try {
        if (flagState['is-checkout-monitoring-enabled']) {
            mbpLogger.logError({
                function: 'buildConfigObj',
                appName: process.env.npm_package_name,
                module: 'mbp-pwa-ui',
                message: 'buildConfigObj - Start',
                orderId: cartId,
            });
        }

        const jwtToken = yield call(checkJWT);
        const paymentMethod = yield select(getPaymentMethod);

        const emailOptIn = yield select(getEmailOptIn);
        const smsOptIn = yield select(getSMSOptIn);
        const orderStatusOptIn = yield select(getOrderStatusOptIn);

        const passportTermsAndConditionChecked = yield select(getPassportSubscriptionStatus);

        const billingAddress = yield select(getBillingAddress);
        const billingInfo = googlePayment?.billingAddress || billingAddress;

        if (billingInfo.isAddressVerified) {
            billingInfo.isAddressVerified = billingInfo.isAddressVerified === 'Y';
        }

        // We setup 3 letter in place order because Miracle products was getting
        // validation cart issue when decline credit card
        const country = billingInfo.country || 'USA';
        if (country.length !== 3) {
            billingInfo.country = getCountryCodeFromTwoToThreeDigit(country) || country;
        }

        const customer = {
            billingAddress: billingInfo,
            emailOptIn,
            smsOptIn,
            cellNumber: billingAddress?.mobileNumber || '',
            passportTermsAndConditionChecked,
            orderStatusOptIn: orderStatusOptIn || false,
        };

        // Builing payment data
        let payment = {
            paymentMethod: 'GiftCard',
        };

        if (disablePaymentFields === false) {
            const paymentInfo = yield select(getPaymentInfo);
            payment = {
                ...paymentInfo,
                brand: CreditCardTypes[paymentInfo.brand],
            };

            if (paymentMethod.id === 'PayPal') {
                payment = {};
                // Set payment method accepted by place order
                payment.paymentMethod = 'paypal';
                const tokenizedPaypalCard = yield select(getPaypalTokenizedCard);
                if (paypalPayment.isTokenizedPaypalCard && tokenizedPaypalCard) {
                    payment.accountNumber = tokenizedPaypalCard;
                    payment.isCardTokenized = true;
                } else if (paypalPayment.nonce) {
                    payment.accountNumber = paypalPayment.nonce;
                }
            } else if (paymentMethod.id === 'GooglePay') {
                payment = {};
                payment.paymentMethod = 'GooglePay';

                const tokenizedGooglePayCard = yield select(getGooglePayTokenizedCard);
                if (googlePayment?.isTokenizedGooglePayCard && tokenizedGooglePayCard) {
                    payment.accountNumber = tokenizedGooglePayCard;
                    payment.isCardTokenized = true;
                } else if (googlePayment?.nonce) {
                    payment.accountNumber = googlePayment.nonce;
                }

                if (googlePayment?.paymentCardType) {
                    payment.brand = googlePayment.paymentCardType;
                    payment.attributes = [{
                        attributeName: 'lastFourDigits',
                        attributeValue: googlePayment.cardlastFourDigit,
                    }];
                }
            } else if (paymentMethod.id === 'Venmo' || venmoPayment?.nonce) {
                payment = {};
                payment.paymentMethod = 'venmo';
                payment.accountNumber = venmoPayment.nonce;
            } else if (paymentMethod.id === 'Klarna' && klarnaPayment?.authorizeCode) {
                payment = {};
                payment.paymentMethod = 'Klarna';
                payment.accountNumber = klarnaPayment.authorizeCode;
            } else if (paymentMethod.id === 'Paze' && pazePayment?.authorizeCode) {
                payment = {};
                payment.paymentMethod = 'Paze';
                payment.accountNumber = pazePayment.authorizeCode;
            } else {
                if (flagState['is-checkout-monitoring-enabled']) {
                    mbpLogger.logError({
                        function: 'buildConfigObj',
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        message: 'Payment Method - Creditcard',
                        orderId: cartId,
                    });
                }

                payment.isCardTokenized = false;
                if (paymentInfo && paymentInfo.isFromWallet) {
                    payment.isCardTokenized = true;
                    payment.walletId = paymentInfo.walletId;
                }

                payment.paymentMethod = 'creditcard';
                payment.accountNumber = removeMaskForAccountNumber(payment.accountNumber);

                const amount = yield select(getAmount);
                payment.amount = amount.orderTotal;

                if (!payment.isCardTokenized) {
                    payment.lastFourDigits = payment.accountNumber.substr(payment.accountNumber.length - 4);
                }

                // If the reward points have information, send it in the payment information
                const rewardPointsInfo = yield select(getRewardPointsInfo);
                if (rewardPointsInfo
                    && rewardPointsInfo.selected
                    && rewardPointsInfo.selected.amount
                    && rewardPointsInfo.selected.points
                ) {
                    payment.rewards = rewardPointsInfo.selected;
                }

                if (payment
                    && payment.expirationMonth
                    && parseInt(payment.expirationMonth, 10) < 10) {
                    const twoDigitMonth = `0${parseInt(payment.expirationMonth, 10)}`;
                    payment.expirationMonth = twoDigitMonth;
                }
                if (payment
                    && payment.expirationYear
                    && parseInt(payment.expirationYear, 10) < 100) {
                    const fourDigitYear = `20${payment.expirationYear}`;
                    payment.expirationYear = fourDigitYear;
                }
            }
        }

        if (flagState['is-checkout-monitoring-enabled']) {
            mbpLogger.logError({
                function: 'workerPaymentPlaceOrder',
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                message: `Accertify data received ${cartId}`,
                orderId: cartId,
            });
        }

        let metadata = {};
        if (flagState['is-checkout-accertify-enabled']) metadata = collectMetadata();

        configObj = {
            env: {},
            jwtToken,
            cartId,
            customer,
            payment,
            recaptcha,
            recaptchaV2,
        };

        if (!isEmpty(metadata)) configObj.metadata = metadata;

        if (source) {
            configObj.sourceApp = source;
        }

        // Unmask Phone Number
        if (configObj.customer.billingAddress.phone) {
            configObj.customer.billingAddress.phoneNumber = removeMaskForPhoneNumber(configObj.customer.billingAddress.phone);
        }

        // Unmask Mobile Phone
        if (configObj.customer.billingAddress.mobilePhone) {
            configObj.customer.billingAddress.mobilePhone = removeMaskForPhoneNumber(configObj.customer.billingAddress.mobilePhone);
            configObj.customer.cellNumber = configObj.customer.billingAddress.mobilePhone;
        }

        if (flagState['is-checkout-monitoring-enabled']) {
            mbpLogger.logError({
                function: 'buildConfigObj',
                appName: process.env.npm_package_name,
                module: 'mbp-pwa-ui',
                message: 'buildConfigObj - End - payload config obj prepared',
                orderId: cartId,
            });
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'buildConfigObj',
            jsError: ex,
            message: 'buildConfigObj Failed',
            orderId: cartId,
        });
    }

    return configObj;
}

const checkIsReviewOrderPage = () => {
    let isReviewOrderPage = false;

    if (typeof window !== 'undefined') {
        if (window.location.href.indexOf('/checkout/review-order') >= 0) {
            isReviewOrderPage = true;
        }
    }

    return isReviewOrderPage;
};

const checkIsPaymentPage = () => {
    let isPaymentPage = false;

    if (typeof window !== 'undefined') {
        if (window.location.href.indexOf('/checkout/payment') >= 0) {
            isPaymentPage = true;
        }
    }

    return isPaymentPage;
};

const orderItemLevelErrors = (errorList = []) => errorList.filter((error) => ((Number(error.fieldName) > 0)));

function* workerPaymentPlaceOrder(action) {
    const cartId = yield select(getOrderId);
    const flagState = yield select(getFeatureFlags);

    try {
        yield put(updateShowLoadingMessage());
        const {
            history, source,
            disablePaymentFields,
            paypalPayment,
            visaCheckoutPayment,
            googlePayment,
            venmoPayment,
            klarnaPayment,
            pazePayment,
            recaptcha,
            recaptchaV2,
        } = action.payload;

        const configObj = yield call(buildConfigObj, {
            disablePaymentFields,
            paypalPayment,
            visaCheckoutPayment,
            googlePayment,
            venmoPayment,
            klarnaPayment,
            pazePayment,
            source,
            recaptcha,
            recaptchaV2,
        });

        if (flagState['is-checkout-monitoring-enabled']) {
            mbpLogger.logError({
                function: 'workerPaymentPlaceOrder',
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                message: `workerPaymentPlaceOrder | START ${cartId}`,
                orderId: cartId,
            });
        }

        // Add the extra attributes if the campaing have.
        yield call(placeOrderExtraAttributes);
        // If the banner exist in the cookie.
        yield fork(persistBanner);
        yield take(saveBannerProcessCheckCompleted().type);

        /**
         * Update user billing adddress if it is login
         * in address book, after order is placed
         * the worker saga is in mbp-checkout
         *
         * TODO :: need to replace once place order saga is moved in mbp-checkout
         */
        yield put(updateBillingAddressInAddressBook());

        // Associate EnterpriseId with guest Email address
        if (flagState['is-enterprise-id-update-enabled']) {
            yield call(workerSagaUpdateEnterpriseId);
        }

        yield put(clearOrderItemErrors(
            cartId,
            'payment',
            { errType: 'clearAllFields', field: '' },
        ));

        if (flagState['is-checkout-monitoring-enabled']) {
            mbpLogger.logInfo({
                function: 'workerPaymentPlaceOrder',
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                message: `Start call placeOrder API - ${cartId}`,
                orderId: cartId,
            });
        }

        // Place Order API Call
        const placeOrderResponse = yield call(
            cartServiceClient.placeOrderCart, configObj,
        );

        if (flagState['is-checkout-monitoring-enabled']) {
            mbpLogger.logError({
                function: 'workerPaymentPlaceOrder',
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                message: ` Place Order API Response - ${cartId}`,
                orderId: cartId,
                jsError: placeOrderResponse?.data,
            });
        }

        const recips = yield select(getRecipients);

        if (placeOrderResponse?.data?.result === 'SUCCESS') {
            if (flagState['is-checkout-monitoring-enabled']) {
                mbpLogger.logError({
                    function: 'workerPaymentPlaceOrder',
                    appName: process.env.npm_package_name,
                    module: 'mbp-checkout',
                    message: `Place Order success - ${cartId}`,
                    orderId: cartId,
                });
            }

            const onePageCheckout = yield select(getOnePageCheckoutSaleForceABTest) || {};
            const isOnePageCheckoutEnabled = flagState['is-one-page-checkout-enabled'] === 'newflow'
                || (
                    flagState['is-one-page-checkout-enabled'] === 'salesforce'
                    && onePageCheckout?.campaign?.campaignResponses?.[0]?.userGroup === 'Default'
                );

            let eventLabel = 'Control Payment Complete';
            if (isOnePageCheckoutEnabled) {
                eventLabel = 'Variant Payment Complete';
            }

            yield put(trackEvent({
                eventCategory: 'Experiment',
                eventAction: 'Progressive Checkout',
                eventLabel,
            }));

            yield put(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'Track Event',
                eventLabel: 'Successful Purchase',
            }));

            if (flagState['is-checkout-monitoring-enabled']) {
                mbpLogger.logError({
                    function: 'workerPaymentPlaceOrder',
                    appName: process.env.npm_package_name,
                    module: 'mbp-checkout',
                    message: `Before call retrieve cart - ${cartId}`,
                    orderId: cartId,
                    jsError: cartId,
                });
            }
            // Get Cart
            if (flagState['is-checkout-monitoring-enabled']) {
                yield call(retrieveCart, true, true);
            } else {
                yield call(retrieveCart, false, true);
            }

            const brand = yield select(getBrand);
            const clickStreamPayload = payloadClickStreamPlaceOrder(recips, cartId, brand);

            yield put(paymentPlaceOrderCompleted(clickStreamPayload));
            if (flagState['is-clickstream-order-complete-event-enabled']) {
                yield put(clickStreamOrderComplete(configObj.payment));
            }

            yield put(paymentClearUpdateFields());
            yield put(billingAddressClearForm());

            yield put(billingAddressCheckSameAsDeliveryAddress(false));
            yield put(clearPaypalState());

            // clear banner codes attemps when an order is completed
            yield put(setMfeBannerCodesAttempted([]));

            yield put(unsubscribeOrderStatus());
            yield put(unsubscribeTextmsg());
            yield put(unsubscribeEmail());

            // Delete persistPageData from storage once user has purchased what they were looking for
            if (flagState['is-personalization-recently-viewed-products-enabled']) {
                yield call(removePersistPageDataFromStorage);
            }

            const amount = yield select(getAmount);
            // send attribution data to events api for reporting
            const attributionData = orderCompleteAttributionData(cartId, amount.orderTotal, brand?.code, flagState);
            if (attributionData) {
                yield put(postOrderCompleteAttributionData(attributionData));
            }
            if (flagState['is-checkout-monitoring-enabled']) {
                console.log('Calling redirect confirmation ->', history);
            }

            history.push(`/checkout/order-confirmation/${cartId}`);

            // update membershipType and userRole in localStorage after purchasing passport order
            const hasPassportItem = yield select(isPassportInCart);
            const userInfoLocalStorage = getTokenLocalStorage('userInfo');
            if (hasPassportItem && userInfoLocalStorage) {
                const objUserInfo = JSON.parse(userInfoLocalStorage);
                objUserInfo.profile.membershipType = 'P';
                objUserInfo.profile.userRole = 'P';
                setTokenLocalStorage(true, 'refreshMetadata');
                yield put(setProfileDetails(objUserInfo.profile));
            }

            if (hasPassportItem) {
                yield put(trackEvent({
                    eventCategory: 'Checkout',
                    eventAction: 'Passport Module',
                    eventLabel: 'Passport Placed',
                }));
            }
        } else {
            console.log('Place order failed: ', placeOrderResponse.data);
            yield put(paymentUpdateFormStatus(false));
            yield put(flagOffShowLoadingMessage());
            throw new Error(`${placeOrderResponse.data}`);
        }
    } catch (ex) {
        const { history } = action.payload;
        console.log('Order Id:', cartId);
        console.log('Error Place Order:', ex);
        console.log('Error Place Order:', ex?.response);
        console.log('Error data:', ex.response?.data);
        mbpLogger.logError({
            function: 'workerPaymentPlaceOrder',
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            message: 'Failed workerPaymentPlaceOrder',
            jsError: ex,
            orderId: cartId,
        });

        const errorKey = ex.response?.data?.errorKey || [];
        const validationErrors = ex.response?.data?.fieldErrors || [];
        const orderItemErrors = orderItemLevelErrors(validationErrors);

        if (orderItemErrors.length > 0) {
            yield fork(processFeatureErrors, {
                data: {
                    orderItemId: cartId,
                    errorFeatureType: 'recipient',
                    errorValues: ex.response?.data,
                },
            });

            setTimeout(() => {
                anchorErrorCommonMessage();
            }, 300);
        }

        yield fork(processFeatureErrors, {
            data: {
                orderItemId: cartId,
                errorFeatureType: 'payment',
                errorValues: ex.response?.data,
            },
        });

        // We are adding a flag for we dont send anymore the user back to shippping page
        // because is confusing the user when the issue is related to delivery date
        // we only redirect if the error are related to payment inputs
        // if the flag is off we redirect to shipping page
        // if the flag is on the user stay in review page showing the errors on the product items
        if (flagState['is-item-errors-show-on-review-page-enabled']) {
            if (orderItemErrors?.length <= 0 && checkIsReviewOrderPage() && errorKey !== 'VALIDATION_REQUIRED') {
                history.push(`/checkout/payment/${cartId}`);
            }
        } else if (orderItemErrors?.length > 0 && (checkIsReviewOrderPage() || checkIsPaymentPage())) {
            history.push(`/checkout/shipping/${cartId}`);
        } else if (checkIsReviewOrderPage() && errorKey !== 'VALIDATION_REQUIRED') {
            history.push(`/checkout/payment/${cartId}`);
        }

        // Expection key becase we dont want set isFormValid false since we are
        // looking for recaptcha to be checked or order that are from product level
        if (errorKey !== 'VALIDATION_REQUIRED' && orderItemErrors.length <= 0) {
            yield put(paymentUpdateFormStatus(false));
        }

        yield put(flagOffShowLoadingMessage());
    }
    if (action.payload?.handleCallback) {
        yield call(action.payload.handleCallback, '.errorMessage');
    }
}

function* paymentPlaceOrderWatcher() {
    let action = yield take(paymentPlaceOrder().type);
    while (action !== END) {
        yield call(workerPaymentPlaceOrder, action);
        action = yield take(paymentPlaceOrder().type);
    }
}

function* workerApplePayMerchantProcess() {
    try {
        // If the banner exist in the cookie.
        yield fork(persistBanner);
        yield take(saveBannerProcessCheckCompleted().type);
    } catch (ex) {
        mbpLogger.logError({
            function: 'onApplePayMerchantSuccess',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Failed - onApplePayMerchantSuccess',
            jsError: ex,
        });
    }
}

function* applePayMerchantProccessWatcher() {
    yield takeLatest(applePayMerchantProcess().type, workerApplePayMerchantProcess);
}

// Watcher Sagas
const watchers = [
    fork(paymentPlaceOrderWatcher),
    fork(applePayMerchantProccessWatcher),
];

export {
    watchers,
    workerPaymentPlaceOrder,
};
